import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CustomLabelResponse } from '../models/custom-label-response';
import { User } from '../../auth/models/User';
import { CustomLabelStore } from '../service/custom-label.store';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { OnyxEvent } from '../models/event';
import { EventUtils } from '../utils/event-utils';

@Component({
  selector: 'pioneer-custom-fields-form',
  templateUrl: './custom-fields-form.component.html',
  styleUrls: ['./custom-fields-form.component.css']
})
export class CustomFieldsFormComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  @Input()
  public parentForm: FormGroup;

  @Input()
  public isNewEvent = false;

  customLabels$: Observable<CustomLabelResponse>;
  user$: Observable<User>;

  customEventFieldsForm: FormGroup;

  constructor(private formBuilder: FormBuilder,
              private authenticationStore: AuthenticationStore,
              private customLabelStore: CustomLabelStore) { }

  ngOnInit() {
    this.customLabels$ = this.customLabelStore.customLabels;

    this.customEventFieldsForm = this.formBuilder.group({
      'userRef01': this.getUserRef(this.onyxEvent, 'userRef01'),
      'userRef02': this.getUserRef(this.onyxEvent, 'userRef02'),
      'userRef03': this.getUserRef(this.onyxEvent, 'userRef03'),
      'userRef04': this.getUserRef(this.onyxEvent, 'userRef04'),
      'userRef05': this.getUserRef(this.onyxEvent, 'userRef05')
    });
    this.parentForm.setControl('customFields', this.customEventFieldsForm);
  }

  private getUserRef(event: OnyxEvent, fieldName: string) {
    return EventUtils.getEventUserRef(event, this.authenticationStore.isAgencyUser(), fieldName);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/custom-fields-form/custom-fields-form.component.ts